import { LoanApplicationTabName } from './loanApplication';

export const SECTION_TO_HIDDEN_TAB_NAMES = {
  Borrower: [LoanApplicationTabName.BORROWERS],
  Financials: [LoanApplicationTabName.FINANCIAL_INFO],
  Pricing: [],
  Documents: [LoanApplicationTabName.DOCUMENTS],
  Conditions: [],
};
